<template>
  <div class="centerx popup">
    <vs-popup class="holamundo" icon-close="x" :title="this.title" :active.sync="active">
      <div class="content">
        <textarea disabled rows="20" style="width:100%">{{text_content}}</textarea>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data()  {
      return {
        active: false,
        title: "",
        text_content: "",
      }
  },
  methods: {


    toggle(textToPrint) {

      this.text_content = textToPrint;
      this.active = true;
    }
  }
}
</script>